"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
const _1 = require(".");
function default_1({ invalidateUserInfo, confirm, }) {
    const [switching, setSwitching] = (0, react_1.useState)(false);
    const activateProfile = (id) => {
        setSwitching(true);
        (0, _1.switchProfile)({
            profileId: id,
            retryCount: 5,
            onSuccess: () => {
                invalidateUserInfo();
                (0, functions_1.delay)(1000).then(() => setSwitching(false));
            },
            onError: () => confirm({
                description: (0, string_utils_1.logoutRequiredMsg)(),
                cancellationButtonProps: { style: { display: 'none' } },
                allowClose: false,
            })
                .then(functions_1.logout)
                .catch(() => { }),
        });
    };
    return { switching, activateProfile };
}
exports.default = default_1;
